import { addIcons } from 'ionicons';
import {
  accessibilityOutline,
  add,
  addCircle,
  addCircleOutline,
  addOutline,
  alarmOutline,
  albumsOutline,
  alertCircle,
  alertCircleOutline,
  analytics,
  analyticsOutline,
  appsOutline,
  arrowBack,
  arrowBackOutline,
  arrowDownOutline,
  arrowForward,
  arrowForwardCircle,
  arrowForwardCircleOutline,
  arrowForwardOutline,
  arrowUndoOutline,
  arrowUpOutline,
  atOutline,
  attachOutline,
  ban,
  banOutline,
  barbellOutline,
  bed,
  bedOutline,
  barChartOutline,
  basketball,
  basketballOutline,
  bodyOutline,
  briefcaseOutline,
  bulb,
  bulbOutline,
  business,
  businessOutline,
  cafeOutline,
  calculatorOutline,
  calendar,
  calendarClear,
  calendarClearOutline,
  calendarNumber,
  calendarNumberOutline,
  calendarOutline,
  call,
  callOutline,
  camera,
  cameraOutline,
  card,
  cardOutline,
  caretDownOutline,
  caretUpOutline,
  carOutline,
  cartOutline,
  cash,
  cashOutline,
  chatboxEllipsesOutline,
  checkbox,
  checkboxOutline,
  checkmark,
  checkmarkCircle,
  checkmarkCircleOutline,
  checkmarkDone,
  checkmarkDoneCircleOutline,
  checkmarkDoneOutline,
  checkmarkOutline,
  chevronBackOutline,
  chevronDown,
  chevronDownCircleOutline,
  chevronDownOutline,
  chevronExpandOutline,
  chevronForward,
  chevronForwardOutline,
  chevronUp,
  chevronUpOutline,
  close,
  closeCircleOutline,
  closeOutline,
  cloudUploadOutline,
  cogOutline,
  construct,
  constructOutline,
  copy,
  copyOutline,
  create,
  createOutline,
  cubeOutline,
  diamond,
  diamondOutline,
  documentOutline,
  documentText,
  documentTextOutline,
  downloadOutline,
  ellipse,
  ellipseOutline,
  ellipsisHorizontal,
  ellipsisVertical,
  expandOutline,
  eye,
  eyeOffOutline,
  eyeOutline,
  fastFood,
  fastFoodOutline,
  fileTrayOutline,
  filter,
  filterOutline,
  fitness,
  fitnessOutline,
  flag,
  flagOutline,
  flash,
  flashOutline,
  flaskOutline,
  folderOpenOutline,
  footballOutline,
  footstepsOutline,
  funnelOutline,
  gitBranchOutline,
  gitCompareOutline,
  giftOutline,
  globe,
  globeOutline,
  golfOutline,
  grid,
  gridOutline,
  heartOutline,
  helpCircle,
  helpCircleOutline,
  home,
  homeOutline,
  hourglassOutline,
  idCardOutline,
  image,
  imagesOutline,
  infiniteOutline,
  informationCircle,
  informationCircleOutline,
  languageOutline,
  laptopOutline,
  layers,
  layersOutline,
  link,
  linkOutline,
  list,
  listCircleOutline,
  listOutline,
  location,
  locationOutline,
  lockClosed,
  lockClosedOutline,
  lockOpen,
  lockOpenOutline,
  logInOutline,
  logOutOutline,
  logoWhatsapp,
  mail,
  mailOpenOutline,
  mailOutline,
  maleFemaleOutline,
  mapOutline,
  megaphoneOutline,
  notificationsCircleOutline,
  notificationsOutline,
  options,
  optionsOutline,
  pauseCircle,
  pauseCircleOutline,
  pencilOutline,
  people,
  peopleOutline,
  person,
  personAdd,
  personAddOutline,
  personCircle,
  personCircleOutline,
  personOutline,
  phonePortraitOutline,
  playCircle,
  playCircleOutline,
  playOutline,
  podiumOutline,
  pricetag,
  pricetagOutline,
  pricetagsOutline,
  pulseOutline,
  qrCode,
  qrCodeOutline,
  radioButtonOnOutline,
  readerOutline,
  receipt,
  receiptOutline,
  refresh,
  refreshCircleOutline,
  refreshOutline,
  removeCircleOutline,
  removeOutline,
  repeat,
  repeatOutline,
  resizeOutline,
  restaurantOutline,
  returnDownBackOutline,
  rocketOutline,
  save,
  saveOutline,
  scanOutline,
  school,
  schoolOutline,
  search,
  searchCircle,
  searchOutline,
  send,
  sendOutline,
  settings,
  settingsOutline,
  shareSocial,
  shareSocialOutline,
  shieldCheckmark,
  shieldCheckmarkOutline,
  sparklesOutline,
  squareOutline,
  star,
  starHalf,
  starOutline,
  statsChart,
  stopCircle,
  stopCircleOutline,
  stopOutline,
  storefront,
  storefrontOutline,
  sunny,
  sunnyOutline,
  swapHorizontal,
  swapHorizontalOutline,
  swapVerticalOutline,
  sync,
  syncOutline,
  tennisballOutline,
  ticketOutline,
  time,
  timeOutline,
  timer,
  timerOutline,
  toggle,
  trailSignOutline,
  trash,
  trashOutline,
  trendingUp,
  trendingUpOutline,
  trendingDownOutline,
  trophy,
  trophyOutline,
  videocamOffOutline,
  videocamOutline,
  volumeHighOutline,
  volumeMuteOutline,
  wallet,
  walletOutline,
  warning,
  warningOutline,
  waterOutline,
  wifiOutline,
  peopleCircleOutline,
  arrowDownCircleOutline,
  moonOutline,
  closeCircle,
  logoGooglePlaystore,
  logoApple,
} from 'ionicons/icons';

export function configureIcons() {
  addIcons({
    add,
    peopleCircleOutline,
    arrowDownCircleOutline,
    moonOutline,
    closeCircle,
    logoGooglePlaystore,
    logoApple,
    logOutOutline,
    chevronUp,
    calendarOutline,
    ellipsisHorizontal,
    ellipsisVertical,
    checkmarkOutline,
    checkmarkDoneOutline,
    chevronForwardOutline,
    personOutline,
    footballOutline,
    ellipse,
    addCircleOutline,
    close,
    createOutline,
    informationCircleOutline,
    alarmOutline,
    chatboxEllipsesOutline,
    flagOutline,
    timeOutline,
    accessibilityOutline,
    eyeOutline,
    star,
    construct,
    checkmarkCircleOutline,
    storefrontOutline,
    copyOutline,
    squareOutline,
    checkboxOutline,
    callOutline,
    mapOutline,
    documentTextOutline,
    notificationsOutline,
    notificationsCircleOutline,
    checkmarkDoneCircleOutline,
    readerOutline,
    logInOutline,
    homeOutline,
    personCircleOutline,
    mailOpenOutline,
    shieldCheckmarkOutline,
    cashOutline,
    sendOutline,
    trashOutline,
    checkbox,
    chevronDownOutline,
    wifiOutline,
    waterOutline,
    maleFemaleOutline,
    carOutline,
    footstepsOutline,
    videocamOffOutline,
    fastFoodOutline,
    restaurantOutline,
    cafeOutline,
    cardOutline,
    chevronUpOutline,
    removeCircleOutline,
    playCircleOutline,
    addOutline,
    saveOutline,
    pencilOutline,
    analyticsOutline,
    gitCompareOutline,
    personAddOutline,
    logoWhatsapp,
    trophyOutline,
    lockOpenOutline,
    lockClosedOutline,
    cartOutline,
    peopleOutline,
    locationOutline,
    tennisballOutline,
    barChartOutline,
    linkOutline,
    trailSignOutline,
    alertCircleOutline,
    megaphoneOutline,
    refreshCircleOutline,
    eyeOffOutline,
    chevronExpandOutline,
    arrowDownOutline,
    arrowUpOutline,
    chevronDownCircleOutline,
    pauseCircleOutline,
    closeCircleOutline,
    caretDownOutline,
    caretUpOutline,
    arrowBackOutline,
    schoolOutline,
    searchOutline,
    banOutline,
    pricetagOutline,
    mailOutline,
    businessOutline,
    scanOutline,
    arrowBack,
    shareSocialOutline,
    videocamOutline,
    informationCircle,
    people,
    settings,
    basketball,
    time,
    fitness,
    calendar,
    card,
    personAdd,
    create,
    calendarNumber,
    person,
    flag,
    cash,
    personCircle,
    list,
    receipt,
    timerOutline,
    checkmarkCircle,
    calendarClear,
    receiptOutline,
    timer,
    location,
    stopCircle,
    playCircle,
    school,
    infiniteOutline,
    walletOutline,
    calendarClearOutline,
    calendarNumberOutline,
    flaskOutline,
    closeOutline,
    toggle,
    image,
    warningOutline,
    basketballOutline,
    stopOutline,
    playOutline,
    business,
    diamond,
    arrowForwardOutline,
    constructOutline,
    trash,
    lockClosed,
    copy,
    storefront,
    lockOpen,
    link,
    shieldCheckmark,
    qrCode,
    shareSocial,
    diamondOutline,
    analytics,
    rocketOutline,
    barbellOutline,
    chevronBackOutline,
    languageOutline,
    helpCircleOutline,
    laptopOutline,
    expandOutline,
    cameraOutline,
    qrCodeOutline,
    pauseCircle,
    home,
    options,
    checkmark,
    sync,
    addCircle,
    globe,
    eye,
    bulb,
    arrowForward,
    globeOutline,
    chevronForward,
    mail,
    documentText,
    call,
    cogOutline,
    bulbOutline,
    calculatorOutline,
    listOutline,
    camera,
    appsOutline,
    flash,
    ellipseOutline,
    grid,
    searchCircle,
    fitnessOutline,
    atOutline,
    filter,
    search,
    ban,
    warning,
    repeat,
    repeatOutline,
    save,
    swapHorizontal,
    trendingUp,
    helpCircle,
    pricetag,
    refresh,
    alertCircle,
    wallet,
    swapHorizontalOutline,
    swapVerticalOutline,
    podiumOutline,
    phonePortraitOutline,
    settingsOutline,
    volumeMuteOutline,
    volumeHighOutline,
    fastFood,
    layers,
    chevronDown,
    idCardOutline,
    returnDownBackOutline,
    cubeOutline,
    downloadOutline,
    send,
    attachOutline,
    cloudUploadOutline,
    syncOutline,
    hourglassOutline,
    folderOpenOutline,
    stopCircleOutline,
    golfOutline,
    pulseOutline,
    flashOutline,
    layersOutline,
    briefcaseOutline,
    ticketOutline,
    removeOutline,
    arrowForwardCircle,
    documentOutline,
    pricetagsOutline,
    refreshOutline,
    gridOutline,
    arrowForwardCircleOutline,
    albumsOutline,
    radioButtonOnOutline,
    optionsOutline,
    listCircleOutline,
    funnelOutline,
    gitBranchOutline,
    sparklesOutline,
    starOutline,
    starHalf,
    sunny,
    sunnyOutline,
    bed,
    bedOutline,
    statsChart,
    checkmarkDone,
    trophy,
    filterOutline,
    bodyOutline,
    fileTrayOutline,
    imagesOutline,
    heartOutline,
    arrowUndoOutline,
    trendingUpOutline,
    trendingDownOutline,
    giftOutline,
    resizeOutline,
  });
}
